import { useEffect, useState } from "react";
import { IoIosArrowUp } from "react-icons/io";
import "./BackToTopBtn.scss";

function BackToTopBtn() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Mostra o botão quando o usuário rola mais de 300px
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <button className="scroll-to-top" onClick={scrollToTop}>
        <IoIosArrowUp size={20} />
      </button>
    )
  );
}

export default BackToTopBtn;